import { getElementTag } from '../../lib/get-element-tag.ts'
import { config } from './config.ts'
import '../../lib/scroll-timeline.js'
import { createTracker, Environment } from '@nrk/dh-snowplow'
import { safeDefine } from '../../lib/safe-define.ts'
import { ViderenavigasjonSveip } from './components/viderenavigasjon-sveip.ce.ts'
import { EventSchema, ViewportEventKind } from '@nrk/snowplow-web'
import '@nrk/core-design-tokens/dist/color/nrk-color-tokens.css'
import './components/viderenavigasjon.module.css'

import './components/bilder/1_bg.webp'
import './components/bilder/1_bg.png'
import './components/bilder/1_forgrunn.webp'
import './components/bilder/1_forgrunn.png'

/* Sak-2 */
import './components/bilder/2_bg.webp'
import './components/bilder/2_bg.png'
import './components/bilder/2_forgrunn.webp'
import './components/bilder/2_forgrunn.png'

/* Sak-2 */
import './components/bilder/3_bg.webp'
import './components/bilder/3_bg.png'
import './components/bilder/3_forgrunn.webp'
import './components/bilder/3_forgrunn.png'

/* Sak-2 */
import './components/bilder/4_bg.webp'
import './components/bilder/4_bg.png'
import './components/bilder/4_forgrunn.webp'
import './components/bilder/4_forgrunn.png'

const tag = getElementTag(__APP_NAME__, config.moduleName, __APP_VERSION__)
class AppElement extends HTMLElement {
  #tracker
  #entryObserver
  #exitObserver

  connectedCallback() {
    safeDefine('viderenavigasjon-sveip', ViderenavigasjonSveip)
    this.#createTracker()
    this.#initABTest()
    this.#startViewportLogger()
    this.addEventListener('dh-basis-sveip-active-changed', this.#handleActiveChanged)
  }

  disconnectedCallback() {
    this.#stopViewportLogger()
    this.removeEventListener('dh-basis-sveip-active-changed', this.#handleActiveChanged)
  }

  #createTracker() {
    if (process.env.DEV) {
      // @ts-ignore
      import('@nrk/dh-snowplow/mock').then(({ mock }) => mock()).catch(console.error)
    }

    this.#tracker = createTracker('dh-instuliv-viderenavigasjon', {
      environment: process.env.ENVIRONMENT as Environment,
      contentContext: {
        source: 'pp',
        id: this.dataset.selfId,
      },
    })
  }

  #handleActiveChanged = (e) => {
    this.#tracker.trackSelfDescribingEvent({
      schema: EventSchema.StepEvent,
      data: {
        current: e.detail.nextIndex + 1,
        total: this.#scrollContainerChildren.length,
      },
    })
  }

  #startViewportLogger() {
    this.#entryObserver = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) {
        return
      }
      this.#entryObserver.disconnect()
      this.#exitObserver.observe(this)
      this.#tracker.trackSelfDescribingEvent({
        schema: EventSchema.ViewportEvent,
        data: {
          kind: ViewportEventKind.Entry,
        },
      })
    }, {})

    this.#exitObserver = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) {
          return
        }
        this.#exitObserver.disconnect()
        this.#tracker.trackSelfDescribingEvent({
          schema: EventSchema.ViewportEvent,
          data: {
            kind: ViewportEventKind.Exit,
          },
        })
      },
      { threshold: [1], rootMargin: '3000px 0px -100% 0px' },
    )

    this.#entryObserver.observe(this)
  }

  #stopViewportLogger() {
    this.#entryObserver?.disconnect()
    this.#exitObserver?.disconnect()
  }

  #initABTest() {
    // AB test label
    let testLabel = false
    const bucket = document.cookie.match('(^|;)\\s*_nrkbucket1\\s*=\\s*([^;]+)')?.pop()
    if (bucket && typeof bucket === 'string') {
      testLabel = Boolean(parseInt(bucket) % 2)
    }

    this.#tracker.trackStructuredEvent({
      action: 'DH-TEST-LES-MER-LABEL',
      category: 'instuliv-viderenavigasjon',
      label: testLabel.toString(),
    })

    if (testLabel) {
      this.classList.toggle('dh-les-mer-label')
    }
  }

  get #scrollContainerChildren() {
    return this.querySelectorAll(`[data-scroll-container] > *`)
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
